import QuestionListTable from './QuestionListTable';

export default QuestionListTable;
